import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule],
    standalone:true,
    providers: [
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    host: {
        class: 'p-lara-light-blue' // Puedes cambiar a indigo, teal, etc.
    }
})
export class AppComponent {
    title = 'erp-front';
}